import React, { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


export default function Snackbars(props) {
  const [open, setOpen] = useState(true);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical:"top", horizontal:"right" }}
        open={open}
        onClose={handleClose}
        autoHideDuration={process.env.REACT_APP_ALERT_AUTO_CLOSE}
      >
        <Alert
          onClose={handleClose}
          severity={props.variant}
          sx={{ width: '100%' }} 
        >
          {props.message}
        </Alert>
      </Snackbar>
    </div>
  )
}